export const open_login_modal = () => ({
	type: 'OPEN_LOGIN_MODAL',
});

export const close_login_modal = () => ({
  	type: 'CLOSE_LOGIN_MODAL',
});